import React from "react";
import { useDepositWithdrawContext } from "src/contexts";
import { Loader, WithdrawalForm, PageLayout } from "src/components";
import { usePaymentsRoutes } from "src/hooks";

const TRUSTPAYMENTS = "TRUSTPAYMENTS";

const WithdrawalPage: React.FC = (): JSX.Element => {
  const { widgetDataLoading, widgetDataError } = useDepositWithdrawContext();
  const { paymentsRoutes, paymentsRoutesLoading, paymentsRoutesError } = usePaymentsRoutes();

  if (widgetDataLoading || widgetDataError || paymentsRoutesLoading || paymentsRoutesError) {
    return <Loader />;
  }

  const isTrust = paymentsRoutes.psp_service_id === TRUSTPAYMENTS;

  return (
    <PageLayout centered={!isTrust} borderless={isTrust}>
      <WithdrawalForm paymentsRoutes={paymentsRoutes} />
    </PageLayout>
  );
};

export default WithdrawalPage;
